module.exports = __webpack_public_path__ + "img/Butterfly_00381.4ad11b16.png";